import React from "react";
import { useDispatch } from "react-redux";
import { Button, Stack, Typography } from "@mui/material";

import { setDialog } from "../../../features/dialog/dialogSlice";
import useAuth from "../../../hooks/useAuth";
import { useGetTenantInformationQuery } from "../../../features/tenants/tenantsApiSlice";
import { allowNewSite, getCurrentSitesCount } from "../../../utils/tenantUtils";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";

const SitesMenu = () => {
  const dispatch = useDispatch();
  const { isAdmin } = useAuth();
  const { data: tenant, isLoading: isLoadingTenant } =
    useGetTenantInformationQuery(undefined, {
      refetchOnMountOrArgChange: true,
    });

  const siteCount = tenant && getCurrentSitesCount(tenant);

  const handleOpenNewSiteDialog = () => {
    if (allowNewSite(tenant)) {
      dispatch(
        setDialog({ title: "Neuen Standort erstellen", type: "CREATE" })
      );
    } else {
      dispatch(
        setDialog({
          title: "Maximale Anzahl an Standorten erreicht!",
          type: "REDIRECT",
          text: "Die maximale Anzahl an Standorten für diesen Account wurde erreicht. Wenn Sie mehr Standorte benötigen, buchen Sie bitte unter Einstellungen -> Module -> WEITERE STANDORTE BUCHEN die gewünschte Anzahl an Standorten hinzu.",
          redirectTo: "/dashboard/settings/modules",
          redirectButtonText: "ZUR BUCHUNGSSEITE",
        })
      );
    }
  };

  return (
    <div>
      {isLoadingTenant && <LoadingScreen />}
      <Stack
        direction="row"
        justifyContent={"space-between"}
        spacing={2}
        sx={{ mb: 2 }}
      >
        {isAdmin && (
          <Button
            variant="contained"
            color="secondary"
            sx={{
              mt: 2,
              mb: 3,
              fontSize: "125%",
            }}
            onClick={() => handleOpenNewSiteDialog()}
          >
            Neuer Standort
          </Button>
        )}
        <Typography variant="h4" sx={{ py: 2 }}>
          Standorte: {siteCount}
        </Typography>
      </Stack>
    </div>
  );
};

export default SitesMenu;
